<template>
  <smart-banner
    v-if="!hasConflict"
    :bg-color="bgColor"
    direction="row-reverse"
    :has-kicker="true"
    kicker-color="#717D96"
    kicker-weight="700"
    kicker-align="left"
    title-color="#3b3b3b"
    title-size="h2"
    title-weight="400"
    title-align="left"
    text-color="#43515A"
    text-size="md"
    text-weight="400"
    text-align="left"
    :has-button="true"
    :has-image="hasImage"
    :image-mobile="imageMobile"
    :image-tablet="imageTablet"
    :image-desktop="imageDesktop"
    :alt="alt"
    :has-video="hasVideo"
  >
    <template #video>
      <slot name="secondary-video" />
    </template>
    <template #kicker>
      <slot name="secondary-kicker" />
    </template>
    <template #title>
      <slot name="secondary-title" />
    </template>
    <template #text>
      <slot name="secondary-text" />
    </template>
    <template #button>
      <slot name="secondary-buttons" />
    </template>
  </smart-banner>
</template>

<script>
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-secondary',
  components: {
    SmartBanner,
  },
  props: {
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    alt: {
      type: String,
    },
    bgColor: {
      type: String,
      default: '#FFFFFF',
    },
    hasVideo: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    hasImage() {
      return Boolean(this.imageMobile || this.imageTablet || this.imageDesktop)
    },
    hasConflict() {
      return this.hasVideo && this.hasImage
    }
  },
}
</script>
